import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { selectEvent } from 'services/events/selectors';
import { selectPeopleKeyedByUserId } from 'services/people/selectors';

const selectEventCreatedBy = createDeepEqualSelector(
    [selectPeopleKeyedByUserId, selectEvent],
    (peopleKeyedByUserId, event) =>
        event?.createdByUserId &&
        get(peopleKeyedByUserId, [event.createdByUserId, 'fullName'], '')
);

export const makeSelectEventCreatedBy = (): typeof selectEventCreatedBy =>
    selectEventCreatedBy;
